import LineCameraPlusIcon from 'components/Luxkit/Icons/line/LineCameraPlusIcon'
import LineCoffeeIcon from 'components/Luxkit/Icons/line/LineCoffeeIcon'
import LineDrinksTrayIcon from 'components/Luxkit/Icons/line/LineDrinksTrayIcon'
import LineFootballBallIcon from 'components/Luxkit/Icons/line/LineFootballBallIcon'
import LineRestaurantIcon from 'components/Luxkit/Icons/line/LineRestaurantIcon'
import LineShoppingBagIcon from 'components/Luxkit/Icons/line/LineShoppingBagIcon'
import LineTreesIcon from 'components/Luxkit/Icons/line/LineTreesIcon'
import LineUniversityIcon from 'components/Luxkit/Icons/line/LineUniversityIcon'
import { PlaceGeo } from 'tripPlanner/types/common'

export const exploreCategories = [
  {
    label: 'Top attractions',
    icon: LineCameraPlusIcon,
  },
  {
    label: 'Restaurants',
    icon: LineRestaurantIcon,
  },
  {
    label: 'Cafes',
    icon: LineCoffeeIcon,
  },
  {
    label: 'Parks',
    icon: LineTreesIcon,
  },
  {
    label: 'Shopping',
    icon: LineShoppingBagIcon,
  },
  {
    label: 'Museums',
    icon: LineUniversityIcon,
  },
  {
    label: 'Bars',
    icon: LineDrinksTrayIcon,
  },
  {
    label: 'Sports',
    icon: LineFootballBallIcon,
  },
] as const

export type ExploreCategory = (typeof exploreCategories)[number]

type ExploreCategoriesLabels = {
  [K in (typeof exploreCategories)[number]['label']]: string
}

export const exploreAnalyticsCategoryLabels: ExploreCategoriesLabels = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'Top attractions': 'top-attractions',
  Restaurants: 'restaurants',
  Cafes: 'cafes',
  Parks: 'parks',
  Shopping: 'shopping',
  Museums: 'museums',
  Bars: 'bars',
  Sports: 'sports',
}

export function formatExploreQuery(place: PlaceGeo, category: ExploreCategory) {
  if (category.label === 'Sports') {
    return `Sports venues in ${place.lePlaceName}`
  }

  return `${category.label} in ${place.lePlaceName}`
}
